import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import App from './App';
import {
  installLoungeAuthRefresh,
  installLoungeAuthorizedFetch,
} from './utils/loungeAuthRefresh';

installLoungeAuthRefresh();
installLoungeAuthorizedFetch();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={''}>
      <Provider store={store}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
